import { $t } from '@/i18n';
import WujiSourceController from './wuji';
import CollectionSourceController from './collection';

import { getPatchedDataSchema } from '@tencent/data-schema-core';
import logger from '@utils/logger';
import { UC_TAG_FROM_TEMPLATE } from '../consts';

export const SourceControllerCtor = {
  wuji: WujiSourceController,
  collection: CollectionSourceController,
};

export function createSourceController(sourceConfig, xiaoyaoPlugin, renderer) {
  const Ctor = SourceControllerCtor[sourceConfig.type];
  if (!Ctor) return null;

  const controller = new Ctor({
    propsData: {
      config: sourceConfig,
      renderer,
      pluginInstance: xiaoyaoPlugin,
    },
    parent: xiaoyaoPlugin,
  });

  const handleLoadSchema = () => {
    // eslint-disable-next-line no-param-reassign
    xiaoyaoPlugin.loadingSchema -= 1;

    // 揉一个新的 dataSchema 进去

    const { ...originalDataSchema } = controller.dataSchema;

    const rootDataSchema = { ...xiaoyaoPlugin.dataSchema };
    const placeholderIndex = rootDataSchema.fields.findIndex(x => x.id === sourceConfig.id);

    const tags = [];

    // wuji-source 特色
    const state = controller.S?.state;
    if (state) {
      const modelTag = state.ucTag || Object.getPrototypeOf(state).constructor.stateModel;  // 比如 “form” / “单接口”
      if (modelTag) tags.push(modelTag);
    }
    // 可更新模板注入的数据源：面板上加「模板」标签
    if (sourceConfig[UC_TAG_FROM_TEMPLATE]) tags.push($t('k_40ead0fd'));

    rootDataSchema.fields = [...rootDataSchema.fields];
    const fromTemplate = !!sourceConfig[UC_TAG_FROM_TEMPLATE];
    // 模板注入的数据源：面板只显示根节点，不展开 query / data / $methods
    const fieldSchema = fromTemplate
      ? {
        id: sourceConfig.id,
        type: 'any',
        title: sourceConfig.id + (sourceConfig.title ? ` (${sourceConfig.title})` : ''),
        'xy:sourceId': sourceConfig.id,
        'uc:tag': tags.length ? tags : null,
        'uc:allowCopyPath': false,
      }
      : {
        ...getPatchedDataSchema(originalDataSchema),
        id: sourceConfig.id,
        title: sourceConfig.id + (sourceConfig.title ? ` (${sourceConfig.title})` : ''),
        'xy:sourceId': sourceConfig.id,
        'uc:tag': tags.length ? tags : null,
        'uc:allowCopyPath': false,
      };
    rootDataSchema.fields[placeholderIndex] = fieldSchema;

    // eslint-disable-next-line no-param-reassign
    xiaoyaoPlugin.dataSchema = Object.freeze(rootDataSchema);
    logger.info('[UICoreXiaoyaoPlugin] DataSchema Updated!', rootDataSchema);
  };

  controller.$on('load-schema', handleLoadSchema);
  const destroyController = () => {
    controller.$destroy();
  };
  xiaoyaoPlugin.$once('hook:beforeDestroy', destroyController);
  controller.$once('hook:beforeDestroy', () => {
    xiaoyaoPlugin.$off('hook:beforeDestroy', destroyController);
  });

  return controller;
}
